<template>
    <div >
        <Card title="批改明细">
            <Form :label-width="120" ref="form" class="mt15">
                <!-- 大地低职业 -->
                <FormItem label="附加险：" class="w600" v-if="info.extraInfo&&info.extraInfo.isSubjoinAllDay">
                    <p v-if="info.extraInfo.isSubjoinAllDay">附加24小时</p>
                </FormItem>
                <!-- 阳光雇主 -->
                 <template v-if="info.extraInfo&&info.productCode=='SUNLIGHT_EMPLOYER_LIABILITY'">
                    <FormItem label="保障方案：" class="w600">{{info.extraInfo.schemeName}}</FormItem>
                    <FormItem label="附加险：" class="w600">
                        <p v-if="info.extraInfo.isSubjoinProportionAdj">十级伤残10%</p>
                        <p v-else>十级伤残5%</p>
                        <p v-if="info.extraInfo.isCanteenAndDormitoryLiability">员工食堂、宿舍责任</p>
                    </FormItem>
                </template>
            </Form>
            <div class="recognize-table mt10 pb20" v-if="info.productCode=='SUNLIGHT_EMPLOYER_LIABILITY'">
                <el-table class="mt10" ref="table" :data="info.subjectMatterGroupStats" border style="width: 100%">
                    <el-table-column type="index" label="序号" width="80"></el-table-column>
                    <el-table-column prop="quoteRiskCategoryName" label="风险类别" min-width="180"></el-table-column>
                    <el-table-column prop="quantity" label="人数" min-width="180" align="right"></el-table-column>
                    <el-table-column prop="unitPremium" label="保费单价（元/人）" min-width="180" align="right"></el-table-column>
                    <el-table-column prop="totalPremium" label="保费小计（元）" min-width="180" align="right"></el-table-column>
                </el-table>
            </div>
            <div v-else>
                <el-table class="mt10" ref="table" :data="tableData" border style="width: 100%" max-height="400">
                    <el-table-column prop="jobTypeName" label="工种" show-overflow-tooltip width="180"></el-table-column>
                    <el-table-column prop="riskCategory" label="职业类别" show-overflow-tooltip width="180">
                        <template slot-scope="{row}">
                            {{riskCategoryShow(row.riskCategory)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="schemeName" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
                    <!-- 大地低职业 -->
                    <el-table-column prop="companyNameFrom" label="派遣单位" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="companyNameTo" label="实际用工单位" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="desc" label="工作描述备注" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="province" label="用工省" width="100"></el-table-column>
                    <el-table-column prop="city" label="用工市" width="100"></el-table-column>
                    <el-table-column prop="district" label="用工区" width="100"></el-table-column>
                    <el-table-column prop="insuredPersonName" label="姓名" width="100"></el-table-column>
                    <el-table-column prop="idCard" label="证件号码" width="180"></el-table-column>
                    <el-table-column prop="gender" label="性别" width="100"></el-table-column>
                    <el-table-column prop="age" label="年龄" width="100"></el-table-column>
                    <el-table-column prop="operation" label="批改类型" width="100">
                        <template slot-scope="{ row }">
                            <span v-if="row.operation=='INIT'">原始投保</span>
                            <span v-else-if="row.operation=='ADD'">新增</span>
                            <span v-else-if="row.operation=='REPLACE'">替换</span>
                            <span v-else-if="row.operation=='EDIT'">编辑</span>
                            <span v-else-if="row.operation=='REMOVE'">退保</span>
                            <span v-else-if="row.operation=='REPLACED'">被替换</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="effectiveStatusDesc" label="保障状态" width="100"></el-table-column>
                    <el-table-column prop="effectiveDateStart" label="保障起期" width="180"></el-table-column>
                    <el-table-column prop="effectiveDateEnd" label="保障止期" width="180"></el-table-column>
                    <el-table-column prop="premium" label="保费（元）" width="180"></el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip width="180"></el-table-column>
                </el-table>
                <Row class="mt10" v-if="tableData.length>0">
                    <Col :span="24" class="right">
                        <el-pagination
                            :current-page="pageinfo.page"
                            :page-size="pageinfo.size"
                            :page-sizes="[10, 50, 100,200]"
                            :total="pageinfo.total"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout="total, sizes, prev, pager, next, jumper"
                        >
                        </el-pagination>
                    </Col>
                </Row>
            </div>
        </Card>
    </div>
    </template>
    <script>
    export default {
        props:{
            info:{
                type: Object,
                default(){
                    return {}
                }
            }
        },
        data () {
            return {
                loading: false,
                status:' ',
                subjectMatter: [],
                tableData:[],
                pageinfo: {
                    page: 1,
                    size: 100,
                    total: 0,
                }
            }
        },
        watch: {
            info: function(newVal,oldVal){
                this.subjectMatter = newVal.subjectMatter;
                this.pageinfo.total = this.subjectMatter.length;
                this.tableData =  this.currentChangePage(this.pageinfo.size,this.pageinfo.page)
            }
        },
        methods:{
            riskCategoryShow(name){
                let str = ''
                switch(name){
                    case 'RISK_1':
                        str = "一类"
                    break;
                    case 'RISK_2':
                        str = "二类"
                    break;
                    case 'RISK_3':
                        str = "三类"
                    break;
                    case 'RISK_4':
                        str = "四类"
                    break;
                    case 'RISK_5':
                        str = "五类"
                    break;
                    case 'RISK_6':
                        str = "六类"
                    break;
                    case 'RISK_7':
                        str = "七类"
                    break;
                    default:
                        str = ""
                    break;
                }
                return str
            },
            /** 切换每页显示条数 */
            handleSizeChange(val) {
                this.pageinfo.page = 1;
                this.pageinfo.size = val;
                this.tableData = this.currentChangePage(val, this.pageinfo.page);
                this.pageinfo.total = this.subjectMatter.length;
            },
            /** 切换分页 */
            handleCurrentChange(val) {
                this.pageinfo.page = val;
                this.tableData = this.currentChangePage(this.pageinfo.size, val);
                this.pageinfo.total = this.subjectMatter.length;
            },
            // 分页方法
            currentChangePage(size, current) {
                const tablePush = [];
                let array = this.jsonCopy(this.subjectMatter);
                array.forEach((item, index) => {
                    if (size * (current - 1) <= index && index <= size * current - 1) {
                    tablePush.push(item);
                    }
                });
                return tablePush;
            },
        }
    }
    </script>
    <style scoped>
        .content{
            padding:0 15px 15px;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/riderInfo.vue